import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import banner1 from "../assets/images/banner1.jpg";
import banner2 from "../assets/images/banner2.jpg";
import banner3 from "../assets/images/banner3.jpg";
import banner4 from "../assets/images/banner4.jpg";

const ProductCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Static carousel slides with local banner images
  const carouselSlides = [
    {
      // id: 1,
      // title: "Build Your Solar Energy Project",
      // description:
      // "Come to the more sustainable and economical side of life. Save more with a solar energy system.",
      image: banner1,
    },
    {
      id: 2,
      title: "Nutraceuticals by FIX",
      description:
        "Powered by nature, refined by science: Experience the targeted support of FIX",
      image: banner2,
    },
    {
      id: 3,
      title: "Your Game Starts Here",
      description:
        "Transform your fitness journey with Sportzbee Runs. Professional training and personalized coaching.",
      image: banner3,
      category: "Fitness",
      price: "39,999",
      cta: "Start Now",
    },
    {
      id: 4,
      // title: "Vibrating to Prosperity",
      // description:
      // "Introducing abundance through machine. Experience the power of VATM technology.",
      image: banner4,
    },
  ];

  const carouselProducts = carouselSlides;

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying || carouselProducts.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === carouselProducts.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [isAutoPlaying, carouselProducts.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    // Resume auto-play after 10 seconds
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? carouselProducts.length - 1 : prevIndex - 1
    );
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === carouselProducts.length - 1 ? 0 : prevIndex + 1
    );
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  if (!carouselProducts || carouselProducts.length === 0) {
    return null;
  }

  return (
    <div className="relative w-full overflow-hidden">
      {/* Carousel */}
      <div className="relative">
        {/* Main Carousel Container - Full Width */}
        <div className="relative h-[422px] overflow-hidden">
          {/* Slides */}
          {carouselProducts.map((slide, index) => (
            <div
              key={slide.id}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentIndex ? "opacity-100" : "opacity-0"
              }`}
            >
              {/* Full Width Background Image */}
              <div className="relative w-full h-full">
                <img
                  src={slide.image}
                  alt={slide.title}
                  className="w-full h-full object-cover"
                />
                {/* Overlay for better text readability */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/5 via-black/50 to-transparent"></div>

                {/* Content Overlay */}
                <div className="absolute inset-0 flex items-center">
                  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
                    <div className="max-w-2xl">
                      {/* Category Badge */}
                      {/* <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold bg-fuchsia-600 text-white mb-4">
                        {slide.category}
                      </span> */}

                      {/* Title */}
                      {/* <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
                        {slide.title}
                      </h2> */}

                      {/* Description */}
                      {/* <p className="text-xl md:text-2xl text-gray-200 mb-8">
                        {slide.description}
                      </p> */}

                      {/* Price */}
                      {/* <div className="text-5xl font-bold text-white mb-8">
                        ₹{slide.price}
                      </div> */}

                      {/* Action Buttons */}
                      {/* <div className="flex flex-col sm:flex-row gap-4">
                        <button
                          onClick={() => {
                            // Scroll to products section
                            const productsSection =
                              document.getElementById("products-section");
                            if (productsSection) {
                              productsSection.scrollIntoView({
                                behavior: "smooth",
                              });
                            }
                          }}
                          className="bg-fuchsia-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-purple-700 transition-colors duration-200 shadow-lg text-lg"
                        >
                          {slide.cta}
                        </button>
                        <Link
                          to="/appointments"
                          className="bg-white text-purple-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 text-center text-lg"
                        >
                          Book Consultation
                        </Link>
                      </div> */}

                      {/* Features */}
                      {/* <div className="mt-8 flex flex-wrap gap-6">
                        <div className="flex items-center text-white">
                          <svg
                            className="w-6 h-6 text-green-400 mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                          24/7 Support
                        </div>
                        <div className="flex items-center text-white">
                          <svg
                            className="w-6 h-6 text-green-400 mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                          Proven Results
                        </div>
                        <div className="flex items-center text-white">
                          <svg
                            className="w-6 h-6 text-green-400 mr-2"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                          Money Back Guarantee
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        {carouselProducts.length > 1 && (
          <>
            <button
              onClick={goToPrevious}
              className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-4 rounded-full shadow-lg transition-all duration-200 z-20 hover:scale-110"
              aria-label="Previous slide"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
            <button
              onClick={goToNext}
              className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-4 rounded-full shadow-lg transition-all duration-200 z-20 hover:scale-110"
              aria-label="Next slide"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </>
        )}

        {/* Dots Indicators */}
        {carouselProducts.length > 1 && (
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3 z-20">
            {carouselProducts.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`transition-all duration-300 rounded-full ${
                  index === currentIndex
                    ? "w-12 h-3 bg-fuchsia-800"
                    : "w-3 h-3 bg-white/60 hover:bg-white/90"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCarousel;
